import { Pipe, PipeTransform } from '@angular/core';
import { getNumberedLines } from './text.functions';

@Pipe({ name: 'numberedLines' })
export class NumberedLinesPipe implements PipeTransform {
  transform(inputValue: string): string {
    return getNumberedLines(inputValue);
  }
}
